export default __webpack_public_path__ + "static/media/foto-modal.a9c722b4.png";